import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const NewSalesChart = ({ data }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
            usePointStyle: true,
            padding: 20,
            font: { size: 12, weight: '600' }
        }
      },
      tooltip: {
        backgroundColor: '#111827',
        padding: 12,
        callbacks: {
          label: (context) => {
            return `${context.dataset.label}: ${context.raw.toLocaleString('vi-VN')} điểm`;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: { borderDash: [5, 5] },
        ticks: {
          callback: (value) => (value / 1000000).toLocaleString() + 'M'
        }
      },
      x: {
        grid: { display: false }
      }
    },
    elements: {
        bar: {
            borderRadius: 8, // Bo góc cột cho hiện đại
        }
    }
  };

  const chartData = {
    labels: ['Tài chính (Nạp/Rút)', 'MiniGame (Cược/Thắng)'],
    datasets: [
      {
        label: 'Đầu vào (Nạp/Cược)',
        data: [data.tongnaps, data.tongcuocminigame],
        backgroundColor: 'rgba(33, 150, 243, 0.8)', // Màu xanh dương
        hoverBackgroundColor: '#1976D2',
        barThickness: 50,
      },
      {
        label: 'Đầu ra (Rút/Thắng)',
        data: [data.tongruts, data.tongthangminigame],
        backgroundColor: 'rgba(244, 67, 54, 0.8)', // Màu đỏ
        hoverBackgroundColor: '#D32F2F',
        barThickness: 50,
      },
    ],
  };

  return <Bar options={options} data={chartData} />;
};

export default NewSalesChart;
